
import * as types from './mutation-types'

export const loadPermissions = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/permissions').then((response) => {
            commit(types.ADD_PERMISSIONS, response.data.permissions)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadUserData = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('/user').then((response) => {
            commit(types.ADD_USER_DATA, response.data.user)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

